function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_955",
  "data-name": "Group 955"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_954",
  "data-name": "Group 954"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_659",
  "data-name": "Path 659",
  d: "M476.416,45.433a22.716,22.716,0,1,1,22.716-22.716A22.74,22.74,0,0,1,476.416,45.433Zm0-43.4A20.683,20.683,0,1,0,497.1,22.716,20.7,20.7,0,0,0,476.416,2.033Z",
  transform: "translate(-453.7 0)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_959",
  "data-name": "Group 959",
  transform: "translate(11.028 11.028)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_956",
  "data-name": "Group 956"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_660",
  "data-name": "Path 660",
  d: "M492.374,21.7h-10.52a6.463,6.463,0,0,0-6.454,6.454v10.52a6.463,6.463,0,0,0,6.454,6.454h10.52a6.463,6.463,0,0,0,6.454-6.454V28.154A6.463,6.463,0,0,0,492.374,21.7Zm4.574,16.974a4.641,4.641,0,0,1-4.625,4.625H481.854a4.641,4.641,0,0,1-4.625-4.625V28.2a4.641,4.641,0,0,1,4.625-4.625h10.469a4.641,4.641,0,0,1,4.625,4.625Z",
  transform: "translate(-475.4 -21.7)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_957",
  "data-name": "Group 957",
  transform: "translate(5.489 5.539)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_661",
  "data-name": "Path 661",
  d: "M492.4,32.6a6.2,6.2,0,1,0,6.2,6.2A6.225,6.225,0,0,0,492.4,32.6Zm0,10.215a4.015,4.015,0,1,1,4.015-4.015A3.959,3.959,0,0,1,492.4,42.815Z",
  transform: "translate(-486.2 -32.6)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_958",
  "data-name": "Group 958",
  transform: "translate(16.72 3.964)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_662",
  "data-name": "Path 662",
  d: "M511.044,30.872a1.372,1.372,0,1,1-1.372-1.372A1.366,1.366,0,0,1,511.044,30.872Z",
  transform: "translate(-508.3 -29.5)",
  fill: "#fff"
})));

var SvgInsta = function SvgInsta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_960",
    "data-name": "Group 960",
    width: 45.433,
    height: 45.433,
    viewBox: "0 0 45.433 45.433",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInsta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insta.288366b9.svg";
export { ForwardRef as ReactComponent };